// Standalone-web shim for @airtable/blocks/interface/ui. The web build aliases the SDK import to
// this module so the shared frontend runs outside Airtable. Data comes from useParcelsApi; these
// stubs cover the remaining SDK touchpoints (base id for localStorage keys + export filenames,
// globalConfig-backed saved views fall to localStorage, useRecords empty since the web app reads
// its data through the API shell, not per-table subscriptions).
import { useMemo } from 'react';
export function useBase(): any {
  return useMemo(() => ({ id: 'lfe-web', getTableByIdIfExists: () => null }), []);
}
export function useGlobalConfig(): any {
  return useMemo(() => ({
    get: (_k: string) => undefined,
    hasPermissionToSet: (_k: string) => false,
    setAsync: async (_k: string, _v: any) => {},
  }), []);
}
export function useRecords(_t: any, _o?: any): any[] | null { return []; }
export function useCustomProperties(_fn: any): any { return { customPropertyValueByKey: {} }; }
export function initializeBlock(_c: any): void { /* no-op in web build (web-entry mounts instead) */ }
